<template>
    <div class="vpanel vh-flex card-shadow">
        <ListEmptyView v-if="listUnit.length == 0" @mainClick="newBookUnit" mainButton="新建课程" text="暂无课程"></ListEmptyView>
        <div v-else class="vh-full vh-flex abs-panel">
            <el-scrollbar class="vh-full">
                <div class="inrect">
                    <BookUnitItem @click="unitClick(item)" v-for="(item,index) in listUnit" :key="item" :bookUnit="item"
                        :selected="selectUnit != null && item.unitId == selectUnit.unitId" :seqNo="index+1"></BookUnitItem>
                </div>
            </el-scrollbar>
            <FloatingButton @click="newBookUnit" right="20px" bottom="20px"></FloatingButton>
        </div>
        <!--输入对话框-->
        <InputDialog :showDialog="inputDialog.show" :hint="inputDialog.hint" :defaultText="inputDialog.defaultText"
            :title="inputDialog.title" @selectButton="inputDialog.callBack"></InputDialog>
    </div>
</template>

<script>
import ListEmptyView from '@/components/ListEmptyView.vue'
import InputDialog from '@/components/dialog/InputDialog.vue';
import BookUnitItem from './BookUnitItem.vue'
import FloatingButton from '@/components/FloatingButton.vue'
import httpClient from '@/commom/http/httpClient';
export default {
    name: 'BookDetailsLeftPanel',
    components: {
        ListEmptyView,
        InputDialog,
        BookUnitItem,
        FloatingButton
    },
    props: {
        bookInfo: Object,
        selectUnit: Object,
        listUnit: Array
    },
    data() {
        return {

            ///输入对话框
            inputDialog: {
                show: false,
                title: "",
                hint: "",
                defaultText: "",
                callBack: null
            },
        }
    },
    methods: {
        ///提交事件
        emitEvent: function (name, data) {
            var req = {
                name: name,
                data: data
            }
            this.$emit("eventHandle", req)
        },
        ///单元点击
        unitClick: function (unit) {
            this.emitEvent("selectUnit", unit)
        },
        ///新建课程
        newBookUnit: function () {
            this.inputDialog.title = "新建课程"
            this.inputDialog.hint = "输入课程名称"
            this.inputDialog.show = true
            this.inputDialog.defaultText = ""
            var that = this
            this.inputDialog.callBack = function (res) {
                if (!res.confrim) {
                    that.inputDialog.show = false
                    return
                }
                if (res.text == "") {
                    that.$message.info({ message: "请输入课程名称", duration: 1000, offset: 50 })
                    return
                }

                //调用新建课程接口
                var model = {
                    UnitName: res.text,
                    BookId: that.bookInfo.bookId
                }
                var req = {
                    model: JSON.stringify(model)
                }
                httpClient.invoke("BookUnitAPI.CreateUnit", req, function (res) {
                    if (res.error) {
                        that.$message({ message: res.error })
                        return
                    }
                    that.$message({ message: "新建课程成功" })
                    that.emitEvent("newUnitReload")
                })
                that.inputDialog.show = false

            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vpanel {
    width: 280px;
    background: var(--ek-mainbody-bgcolor);
    margin-left: 30px;
    border-radius: 15px;
    margin-bottom: 20px;
    margin-right: 15px;
}

/* 横屏平板 */
@media (min-width: 900px) and (max-width: 1200px) and (orientation: landscape) {
  .vpanel {
    width: 240px;
  }

}

.inrect {
    margin-top: 15px;
    margin-bottom: 15px;
}
</style>
